import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { not, or } from 'patronum'
import { model as router } from '~/core/router'
import { moviesFavoritesEntityModel } from '~/entities/movies/favorites'
import { showsFavoritesEntityModel } from '~/entities/shows/favorites'
import { tvFavoritesEntityModel } from '~/entities/tv/favorites'
import { profilesFeaturesModel } from '~/features/profiles'
import {
  PATH_LIBRARY_FAVORITES_MOVIES,
  PATH_LIBRARY_FAVORITES_SERIES,
  PATH_LIBRARY_FAVORITES_TV,
} from '~/shared/constants/libraryRoutes'
import { aye } from '~/shared/helpers'

export const loadFavorites = createEvent()
export const resetFavorites = createEvent()

sample({
  clock: loadFavorites,
  filter: not(api.tv.getOnlyFavoritesTvChannelsRowFx.pending),
  target: api.tv.getOnlyFavoritesTvChannelsRowFx,
})

sample({
  clock: loadFavorites,
  filter: not(api.vods.getOnlyFavoritesVodsRowFx.pending),
  target: api.vods.getOnlyFavoritesVodsRowFx,
})

sample({
  clock: loadFavorites,
  filter: not(api.tvshows.getOnlyFavoritesTvShowsRowFx.pending),
  target: api.tvshows.getOnlyFavoritesTvShowsRowFx,
})

sample({
  clock: resetFavorites,
  target: [
    tvFavoritesEntityModel.resetOnlyFavoritesTvChannelsRow,
    moviesFavoritesEntityModel.resetOnlyFavoritesVodsRow,
    showsFavoritesEntityModel.resetOnlyFavoritesTvShowsRow,
  ],
})

export const $favoritesContent = combine({
  tvChannels: tvFavoritesEntityModel.$onlyFavoritesTvChannelsRowFormatted,
  vods: moviesFavoritesEntityModel.$onlyFavoritesVodsRowFormatted,
  tvShows: showsFavoritesEntityModel.$onlyFavoritesTvShowsRowFormatted,
})

export const $isFavoritesContentInited = combine(
  {
    tvChannels: tvFavoritesEntityModel.$onlyFavoritesTvChannelsRow,
    vods: moviesFavoritesEntityModel.$onlyFavoritesVodsRow,
    tvShows: showsFavoritesEntityModel.$onlyFavoritesTvShowsRow,
  },
  ({ tvChannels, vods, tvShows }) => {
    return Boolean(tvChannels && vods && tvShows)
  }
)

export const $isAnyFavorites = combine(
  {
    tvChannels: tvFavoritesEntityModel.$onlyFavoritesTvChannelsRow,
    vods: moviesFavoritesEntityModel.$onlyFavoritesVodsRow,
    tvShows: showsFavoritesEntityModel.$onlyFavoritesTvShowsRow,
  },
  ({ tvChannels, vods, tvShows }) => {
    return Boolean(
      tvChannels?.content.length ||
      vods?.content.length ||
      tvShows?.content.length
    )
  }
)

export const $isAnyFavoritesFxPending = or(
  api.vods.getOnlyFavoritesVodsRowFx.pending,
  api.tv.getOnlyFavoritesTvChannelsRowFx.pending,
  api.tvshows.getOnlyFavoritesTvShowsRowFx.pending
)

export const seeAllLibraryFavoritesTvClick = createEvent()
export const seeAllLibraryFavoritesMovieClick = createEvent()
export const seeAllLibraryFavoritesTvShowsClick = createEvent()

sample({
  clock: seeAllLibraryFavoritesTvClick,
  fn: () => PATH_LIBRARY_FAVORITES_TV,
  target: router.navigatePush,
})

sample({
  clock: seeAllLibraryFavoritesMovieClick,
  fn: () => PATH_LIBRARY_FAVORITES_MOVIES,
  target: router.navigatePush,
})

sample({
  clock: seeAllLibraryFavoritesTvShowsClick,
  fn: () => PATH_LIBRARY_FAVORITES_SERIES,
  target: router.navigatePush,
})

sample({
  clock: profilesFeaturesModel.$selectedProfileId,
  filter: aye,
  target: [
    tvFavoritesEntityModel.$onlyFavoritesTvChannelsRow.reinit,
    moviesFavoritesEntityModel.$onlyFavoritesVodsRow.reinit,
    showsFavoritesEntityModel.$onlyFavoritesTvShowsRow.reinit,
  ],
})
